import system from './system';
import SignIndex from '../view/SignIndex';
import SignInFragment from '../view/SignInFragment';
export default [
  ...system,
  {
    path: '/signIndex',
    element: SignIndex,
    meta: {
      title: '',
      isHeader: false, //是否展示顶部header
      optional: ['time'], //链接中可选参数
    },
  },
  {
    path: '/signInFragment',
    element: SignInFragment,
    meta: {
      title: '碎片明细',
      isHeader: true, //是否展示顶部header
    },
  },
];
